import React, { useState } from "react";
import Loader from "../../components/loader/index";
import { useNavigate } from "react-router-dom";
import styles from "./style.module.css";
import { saveAuthToken } from "../../helper/utils";
import { signIn } from "../../services/auth";

const Login = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);

      const email = e.target.email.value;
      const password = e.target.password.value;
      setLoading(true);
      let payload = {
        email,
        password,
        role: "admin",
      };
      const { status, data } = await signIn(payload);
      if (status === 200) {
        localStorage.setItem("user", JSON.stringify(data));
        setError("");
        navigate("/admin");
        saveAuthToken(data?.data);
      } else {
        setError("Invalid email or password.");
      }
    } catch (err) {
      console.error("Login error:", err);
      setError("An error occurred. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div
        className={`container col-md-6 col-lg-5 p-4 d-flex justify-content-center align-items-center ${styles.height_100}`}
      >
        <div
          className="adminLogin w-100 border border-0 rounded-5 p-sm-5 shadow-lg p-md-4 p-4"
          style={{
            backgroundImage: `url(${require("../../assets/images/OTP.png")})`,
            backgroundSize: "contain",
            backgroundPosition: "bottom center",
            backgroundRepeat: "no-repeat",
          }}
        >
          <h4 className="fw-bold text-center">Hey, Hello</h4>
          <p className="signUp text-center fs_12">
            Enter the information you entered while registering
          </p>
          {error && (
            <div className="alert alert-danger" role="alert">
              {error}
            </div>
          )}
          <form onSubmit={handleSubmit} className="mx-auto w-100 px-2">
            <div className="mb-3">
              <label htmlFor="email" className="form-label fs_12 fw-bold">
                Email address *
              </label>
              <input
                type="email"
                className="form-control"
                id="email"
                aria-describedby="emailHelp"
                name="email"
                required
              />
            </div>
            <div className="mb-3">
              <label htmlFor="password" className="form-label fs_12 fw-bold">
                Password *
              </label>
              <input
                type="password"
                className="form-control"
                id="password"
                name="password"
                required
              />
            </div>
            <div className="mb-3 form-check">
              <input
                type="checkbox"
                className="form-check-input my-1 d-none"
                id="exampleCheck1"
              />
              <div className="d-flex justify-content-between">
                <label
                  className="form-check-label fs_12 my-1"
                  htmlFor="exampleCheck1"
                ></label>
                <a
                  className="forgotpassword fs_12 my-1 link-dark text-decoration-none"
                  href="/"
                >
                  Forget Password
                </a>
              </div>
            </div>
            <button
              disabled={loading}
              type="submit"
              className="mt-4 btn btn-primary btn_contained d-grid gap-2 col-12 p-2"
            >
              {loading ? <Loader /> : "Login"}
            </button>
            <div className="signUpText mt-3 text-center fs_12">
              <p>
                {/* Don't have an account yet?{" "} */}
                <span
                  onClick={() => {
                    // console.log("Plese Click on this to Render this SignUp Page");
                    // navigate("/signup")
                  }}
                  className="link-dark text-decoration-none fw-bold cursor_pointer"
                >
                  {/* Sign Up */}
                </span>
              </p>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default Login;
